import { useQuery } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'

export const useGetCourses = () => {
  const getCourses = async () => {
    const response = await baseClient.get('/learning/users', {
      headers: {
        'Cache-Control': 'no-cache',
      },
    })
    const { data } = response

    return {
      progression: data?.course_progress,
      recommended: data?.recommended_courses ?? [],
      jobTitle: data?.job_title ?? null,
    }
  }

  const response = useQuery({
    queryKey: ['future-learn-courses'],
    queryFn: getCourses,
    useErrorBoundary: false,
    cacheTime: 0,
  })

  return response
}
